/*
 * MOVTECH — urlap-bekuldes popupban/drawerben, oldal-ujratoltes nelkul.
 *
 * A gyari mukodes: a Shopify urlap (contact / customer) bekuldese POST +
 * atiranyitas, tehat az oldal ujratoltodik. A popup viszont csak egy <template>-bol,
 * kattintasra jon letre (lasd assets/block-popup-link.js es a theme.js AskQuestion
 * osztalyat), ezert az ujratoltessel eltunik. A felhasznalo ugy latja, hogy az ablak
 * magatol bezarodott, es nem kap visszajelzest — a „Koszonjuk…" uzenet csak akkor
 * bukkan elo, ha kezzel ujra megnyitja az ablakot.
 *
 * Itt a modalon BELULI urlapokat fetch-csel kuldjuk be, es a valaszt helyben,
 * ugyanabban az ablakban mutatjuk meg. Az ablak nyitva marad.
 *
 * KET PONTON kapcsolodunk be, mert a boltban be van kapcsolva a Shopify hCaptcha
 * spam-vedelme (ce_storefront_forms_captcha_hcaptcha…):
 *
 *   1. submit esemeny (document, bubble) — ez a captcha nelkuli urlapok utja.
 *
 *   2. HTMLFormElement.prototype.submit — ez a captchas urlapok utja. A captcha
 *      script sajat submit-kezelot tesz a formra: azonnal preventDefault-ol,
 *      lefuttatja a hCaptcha-t, a tokent beirja az urlapba, es a VEGEN a
 *      prototipus submit-jevel kuldi be. Az esemenyt tehat mar nem tudjuk elkapni,
 *      ezert a lanc legvegen szolunk kozbe. A captcha igy erintetlenul lefut (a
 *      kihivast is beleertve), csak az utolso lepes lesz a mienk — a token addigra
 *      mar bent van az urlapban, tehat a mi POST-unk is atmegy a vedelmen.
 *
 * Barmi varatlan eseten (ismeretlen valasz, halozati hiba, idotullepes) a gyari
 * utra esunk vissza. A legrosszabb eset tehat pontosan a korabbi viselkedes, nem
 * pedig egy elveszett urlap.
 */
(function () {
  "use strict";

  var TIMEOUT_MS = 15000;
  var MODAL_SELECTOR = ".active-modal-js";
  var nativeSubmit = HTMLFormElement.prototype.submit;

  function strings() {
    var custom = window.movtechFormAjax || {};
    return {
      success: custom.success || "Köszönjük, sikeresen elküldted.",
      close: custom.close || "Bezár",
    };
  }

  function getFormType(form) {
    var input = form.querySelector('input[name="form_type"]');
    return input ? input.value : "";
  }

  function shouldHandle(form) {
    if (!form || typeof form.matches !== "function" || !form.matches("form")) return false;
    if (form.dataset.movtechSent === "true") return false;

    var type = getFormType(form);
    if (type !== "contact" && type !== "customer") return false;

    // A hirlevel kedvezmeny-popupja (discount-modal-popup) az oldal-ujratoltesre
    // epul, lasd assets/modal.js checkUrlParameters(). Azt nem vesszuk at.
    if (type === "customer" && document.querySelector("discount-modal-popup")) return false;

    return Boolean(form.closest(MODAL_SELECTOR));
  }

  function handleSubmit(event) {
    // A tema form-validation.js-e a document CAPTURE fazisaban validal, es hibas
    // urlapnal preventDefault + stopPropagation. A captcha script pedig magan a
    // formon (target fazis) kapja el es allitja meg az esemenyt. Mindketto ele
    // szandekosan NEM tolakszunk: ha barmelyikuk kozbelepett, itt nincs dolgunk.
    if (event.defaultPrevented) return;

    var form = event.target;
    if (!shouldHandle(form)) return;

    event.preventDefault();
    startSubmit(form, event.submitter);
  }

  function startSubmit(form, submitter) {
    if (form.dataset.movtechBusy === "true") return;
    form.dataset.movtechBusy = "true";
    submitForm(form, submitter);
  }

  function submitForm(form, submitter) {
    var controller = new AbortController();
    var timer = setTimeout(function () {
      controller.abort();
    }, TIMEOUT_MS);

    var body = new FormData(form);
    if (submitter && submitter.name) body.append(submitter.name, submitter.value);

    var type = getFormType(form);
    var action = form.getAttribute("action") || window.location.href;

    fetch(action, {
      method: "POST",
      body: body,
      headers: { Accept: "text/html" },
      signal: controller.signal,
    })
      .then(function (response) {
        return response.text().then(function (html) {
          return { response: response, html: html };
        });
      })
      .then(function (result) {
        clearTimeout(timer);
        var outcome = classify(result.response, type);

        if (outcome === "success") {
          showSuccess(form);
          return;
        }

        if (outcome === "error") {
          var text = errorTextFrom(result.html, form.id);
          if (text) {
            showError(form, text);
            return;
          }
        }

        if (outcome === "retry") {
          retryNative(form);
          return;
        }

        // A szerver valaszolt, csak mi nem ertjuk (pl. captcha-kihivas oldal).
        // Ujrakuldes helyett odavisszuk a felhasznalot, ahova a gyari bekuldes is
        // vitte volna — igy az urlap biztosan nem megy ki ketszer.
        delete form.dataset.movtechBusy;
        window.location.assign(result.response.url);
      })
      .catch(function () {
        clearTimeout(timer);
        // Idotullepes vagy halozati hiba: a keres el sem jutott a szerverig, tehat
        // biztonsagos ujrakuldeni a gyari uton.
        nativeFallback(form);
      });
  }

  /*
   * A Shopify a bekuldes utan atiranyit, es a fetch koveti az atiranyitast, ezert
   * a vegso URL arulja el az eredmenyt:
   *   siker : ?contact_posted=true  /  ?customer_posted=true
   *   hiba  : ?form_type=contact&… (a Shopify visszaadja a mezoket, hogy a Liquid
   *           ki tudja irni a form.errors-t)
   * Minden mas ismeretlen.
   */
  function classify(response, type) {
    var url;
    try {
      url = new URL(response.url);
    } catch (e) {
      return "unknown";
    }

    var params = url.searchParams;
    if (type === "contact" && params.get("contact_posted") === "true") return "success";
    if (type === "customer" && params.get("customer_posted") === "true") return "success";
    if (params.get("form_type") === type) return "error";

    // A Shopify 400-at ad pl. hianyzo vagy lejart captcha-token eseten („Missing
    // CAPTCHA token"). Ilyenkor a bekuldes biztosan nem tortent meg.
    if (!response.ok) return "retry";

    return "unknown";
  }

  function errorTextFrom(html, formId) {
    if (!html || !formId) return "";

    try {
      var doc = new DOMParser().parseFromString(html, "text/html");

      // A popup-urlapok a valaszban is <template>-en belul vannak, azok tartalma
      // csak a .content DocumentFragmenten keresztul kereshetok.
      var roots = [doc];
      doc.querySelectorAll("template").forEach(function (node) {
        roots.push(node.content);
      });

      for (var i = 0; i < roots.length; i++) {
        var form = roots[i].querySelector('form[id="' + CSS.escape(formId) + '"]');
        var message = form && form.querySelector(".form__message.error");
        if (message) return message.textContent.replace(/\s+/g, " ").trim();
      }
    } catch (e) {
      return "";
    }

    return "";
  }

  function showSuccess(form) {
    form.dataset.movtechSent = "true";
    delete form.dataset.movtechBusy;

    /* Jelzes a lapnak, hogy a bekuldes sikerult. A kviz-popup erre veszi at a szot
       (assets/movtech-kviz.js), es a sajat eredmeny-kepernyojet mutatja a
       tuzijatekkal es a termek-gombbal az altalanos "Koszonjuk" panel helyett.
       Mas urlapoknal senki nem figyeli, ott ez nem csinal semmit.
       2026-09-09: enelkul a kviz vegen a bekuldes atment, de az eredmeny sosem
       jelent meg, mert a kviz nem ertesult a sikerrol. */
    try {
      form.dispatchEvent(new CustomEvent("movtech:form-success", { bubbles: true }));
    } catch (e) {}

    var panel = buildSuccessPanel(form);
    form.hidden = true;
    form.insertAdjacentElement("beforebegin", panel);

    panel.focus();
    panel.scrollIntoView({ block: "nearest", behavior: "smooth" });
  }

  function buildSuccessPanel(form) {
    var text = strings();

    var panel = document.createElement("div");
    panel.className = "movtech-form-sent form__message success";
    panel.setAttribute("tabindex", "-1");
    panel.setAttribute("role", "status");
    panel.innerHTML =
      '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" class="movtech-form-sent__icon" aria-hidden="true">' +
      '<use href="#icon-success"></use></svg>' +
      '<p class="movtech-form-sent__text"></p>';
    panel.querySelector(".movtech-form-sent__text").textContent = text.success;

    var modal = form.closest(MODAL_SELECTOR);
    var modalClose = modal && modal.querySelector(".modal-button-close");
    if (modalClose) {
      var button = document.createElement("button");
      button.type = "button";
      button.className = "btn btn-outline movtech-form-sent__close";
      button.textContent = text.close;
      button.addEventListener("click", function () {
        modalClose.click();
      });
      panel.appendChild(button);
    }

    return panel;
  }

  function showError(form, text) {
    delete form.dataset.movtechBusy;
    resetSubmitButton(form);

    var previous = form.querySelector(".movtech-form-error");
    if (previous) previous.remove();

    var box = document.createElement("div");
    box.className = "movtech-form-error form__message error mb-10";
    box.setAttribute("role", "alert");
    box.setAttribute("tabindex", "-1");
    box.textContent = text;

    form.insertAdjacentElement("afterbegin", box);
    box.focus();
    box.scrollIntoView({ block: "nearest", behavior: "smooth" });
  }

  // A tema form-validation.js-enek setSubmitButtonLoadingState-je forditva.
  function resetSubmitButton(form) {
    var button = form.querySelector('button[type="submit"]');
    if (!button) return;

    button.classList.remove("loading");
    var spinner = button.querySelector(".icon-load");
    if (spinner) spinner.classList.add("opacity-0", "pointer-none");
    var label = button.querySelector(".hidden-on-load");
    if (label) label.classList.remove("opacity-0");
  }

  /*
   * A form.submit()-et SZANDEKOSAN kerulve: azt a captcha script felulirja a sajat
   * valtozataval, a lenti prototipus-hook pedig ujra minket hivna — vegtelen korre
   * futna. Az elmentett eredeti metodus se esemenyt nem indit, se hookot nem erint.
   */
  function nativeFallback(form) {
    delete form.dataset.movtechBusy;
    nativeSubmit.call(form);
  }

  /*
   * A bekuldes biztosan nem ment at (pl. hianyzo captcha-token), tehat vegigmegyunk
   * a gyari uton. Itt SZANDEKOSAN a form sajat submit()-je kell: azt a captcha
   * script csereli le a sajat valtozatara, ami friss tokent ker. A movtechRetry
   * jelolo miatt a masodik korben mar nem lepunk kozbe, igy nem fut korbe.
   */
  function retryNative(form) {
    delete form.dataset.movtechBusy;
    form.dataset.movtechRetry = "true";
    form.submit();
  }

  document.addEventListener("submit", handleSubmit, false);

  // Lasd a fajl fejleceben a 2. pontot: a captchas urlapok itt futnak be hozzank.
  // Minden mas urlap valtozatlanul a gyari uton megy tovabb.
  HTMLFormElement.prototype.submit = function () {
    if (this.dataset && this.dataset.movtechRetry === "true") {
      delete this.dataset.movtechRetry;
      return nativeSubmit.apply(this, arguments);
    }

    if (shouldHandle(this)) {
      startSubmit(this, null);
      return;
    }

    return nativeSubmit.apply(this, arguments);
  };
})();

